import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import DevTools from "mobx-react-devtools";
import { Link, Redirect, Route, Switch, withRouter } from "react-router-dom";
import "./App.css";
import logoWhite from "./cryptomania-white.svg";
import { Button, Container, Dropdown, Loader, Menu } from "semantic-ui-react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { signOut } from "./auth";
import LoginScreen from "./screens/LoginScreen";
import BuildInfo from "./screens/BuildInfo";
import { serverColorBg, serverNameShort } from "./constants";
import BotInstances from "./bot/BotInstances";
import Trades from "./trade/Trades";
import ExchangeAccounts from "./exchangeAccounts/ExchangeAccounts";
import SimGroups from "./sim/SimGroups";
import Sims from "./sim/Sims";
import SimGroup from "./sim/SimGroup";
import SuspiciousCurrencies from "./exchangeAccounts/SuspiciousCurrencies";
import CandleSticksDownloadStatus from "./exchangeAccounts/CandleSticksDownloadStatus";
import ExchangeAccountBalance from "./exchangeAccounts/ExchangeAccountBalance";
import VolumeStats from "./charts/VolumeStats";

const PATH_BOTS = "/bots";
const PATH_TRADES = "/trades";
const PATH_BUILD_INFO = "/build-info";
const PATH_EXCHANGE_ACCOUNTS = "/exchange-accounts";
const PATH_EXCHANGE_ACCOUNT_BALANCE = "/exchange-account/:exchangeAccountId/balance";
const PATH_SUSPICIOUS_CURRENCIES = "/suspicious_currencies";
const PATH_CANDLE_STICKS_DOWNLOAD_STATUS = "/candle_sticks_download_status";
const PATH_VOLUME_STATS = "/volume_stats";
const PATH_SIM_GROUPS = "/simGroups";
const PATH_SIM_GROUP_VIEW = "/simGroup/";
const PATH_SIMS = "/sims";

@withRouter
@inject("store")
@observer
class App extends Component {
  dev = process.env.NODE_ENV === "development";

  state = {};

  componentDidMount() {
    if (this.dev) {
      import("../package.json").then(packageJson => {
        this.setState({ packageJson });
        console.log("API: " + this.state.packageJson.proxy);
      });
    }

    document.title = (this.dev ? "[DEV] " : "") + "JAbot." + serverNameShort;
  }

  render() {
    const {
      store: {
        isZoneIdUTC,
        toggleZoneId,
        authStore: { initialized: authInitialized, loading: authLoading, isUserSignedIn, userEmail, buildInfo },
      },
      location: { pathname },
    } = this.props;

    if (!isUserSignedIn) return <LoginScreen />;

    return (
      <div className="App">
        {this.dev && <DevTools position={{ top: 0, left: 0 }} />}

        <Menu
          fixed="top"
          inverted
          stackable={false}
          borderless
          style={{
            backgroundColor: serverColorBg,
          }}
        >
          <Menu.Item header>
            <h2>
              <img
                src={logoWhite}
                alt="Logo"
                height={32}
                className="Logo"
                title={this.state.packageJson && "API: " + this.state.packageJson.proxy}
              />JAbot{this.dev && " [DEV]"}
              <Link className="Build" to={PATH_BUILD_INFO}>
                {buildInfo && buildInfo["git.branch"]}
              </Link>
            </h2>
          </Menu.Item>

          <Menu secondary position="left" stackable={false}>
            <Menu.Item as={Link} to={PATH_BOTS} active={pathname.startsWith(PATH_BOTS)}>
              Bots
            </Menu.Item>
            <Menu.Item as={Link} to={PATH_TRADES} active={pathname.startsWith(PATH_TRADES)}>
              Trades
            </Menu.Item>
            <Dropdown item text="Exchanges">
              <Dropdown.Menu>
                <Dropdown.Item
                  as={Link}
                  to={PATH_EXCHANGE_ACCOUNTS}
                  active={pathname.startsWith(PATH_EXCHANGE_ACCOUNTS)}
                >
                  Accounts
                </Dropdown.Item>
                <Dropdown.Item
                  as={Link}
                  to={PATH_SUSPICIOUS_CURRENCIES}
                  active={pathname.startsWith(PATH_SUSPICIOUS_CURRENCIES)}
                >
                  Suspicious Currencies
                </Dropdown.Item>
                <Dropdown.Item
                  as={Link}
                  to={PATH_CANDLE_STICKS_DOWNLOAD_STATUS}
                  active={pathname.startsWith(PATH_CANDLE_STICKS_DOWNLOAD_STATUS)}
                >
                  Candle Sticks Download Status
                </Dropdown.Item>
                <Dropdown.Item as={Link} to={PATH_VOLUME_STATS} active={pathname.startsWith(PATH_VOLUME_STATS)}>
                  Volume stats
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <Menu.Item as={Link} to={PATH_SIM_GROUPS} active={pathname.startsWith(PATH_SIM_GROUPS)}>
              Sim Groups
            </Menu.Item>
            {/*<Menu.Item  as={Link} to={PATH_SIMS} active={pathname.startsWith(PATH_SIMS)}>Sims</Menu.Item>*/}
          </Menu>

          <Menu.Menu position="right">
            `{" "}
            <Menu.Item>
              <Button content="UTC" icon="clock" toggle active={isZoneIdUTC} onClick={toggleZoneId} />
            </Menu.Item>
            {(!authInitialized || authLoading) && (
              <Menu.Item>
                <Loader inline active />
              </Menu.Item>
            )}
            {authInitialized &&
              !authLoading &&
              isUserSignedIn && <Menu.Item onClick={() => signOut()}>{"Sign Out " + userEmail}</Menu.Item>}
          </Menu.Menu>
        </Menu>

        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          pauseOnHover
        />

        <Container fluid style={{ marginTop: "4em", marginBottom: "1em", marginLeft: "1em" }}>
          <Switch>
            <Redirect from="/" exact to={PATH_BOTS} />
            <Route exact path={PATH_BOTS} component={BotInstances} />
            <Route exact path={PATH_TRADES} component={Trades} />
            <Route path={PATH_BUILD_INFO} component={BuildInfo} />
            <Route path={PATH_EXCHANGE_ACCOUNTS} component={ExchangeAccounts} />
            <Route path={PATH_EXCHANGE_ACCOUNT_BALANCE} component={ExchangeAccountBalance} />
            <Route path={PATH_SUSPICIOUS_CURRENCIES} component={SuspiciousCurrencies} />
            <Route path={PATH_CANDLE_STICKS_DOWNLOAD_STATUS} component={CandleSticksDownloadStatus} />
            <Route path={PATH_VOLUME_STATS} component={VolumeStats} />
            <Route exact path={PATH_SIM_GROUPS} component={SimGroups} />
            <Route path={PATH_SIM_GROUP_VIEW + ":simGroupId"} component={SimGroup} />
            <Route exact path={PATH_SIMS} component={Sims} />
          </Switch>
        </Container>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js